import { resolveAppEnv } from './appEnv';

export function isLeadSourcesEnabled(): boolean {
  return resolveAppEnv() !== 'production';
}

export function isHeaderSearchEnabled(): boolean {
  return resolveAppEnv() !== 'production';
}

function isLocalDevelopmentServer(): boolean {
  return process.env.NODE_ENV === 'development';
}

export function isWhatsAppEnabled(): boolean {
  return isLocalDevelopmentServer();
}

export function isCampaignsEnabled(): boolean {
  return isLocalDevelopmentServer();
}
